import React, { useState } from 'react';

import { Box, Container, Tab, Tabs } from '@mui/material';

import { ROLE_ADMIN_USER, ROLE_EXPERIENCES_COORDINATOR } from '~/consts/roles';

import useCurrentUser from '~/hooks/useCurrentUser';

import canShowTab from '~/utils/canShowTab';

import CarouselMetricsTab from './Content/CarouselMetrics/CarouselMetricsTab';
import Collections from './Content/Collections/Collections';
import RegionCuration from './Content/RegionCuration/RegionCuration';
import SyncOffers from './Content/SyncOffers/SyncOffers';
import { ExperiencesContent } from './ExperiencesContent';

export type FieldValueParams = {
  key: string;
  fieldValue: string;
  range?: 'min' | 'max';
};

export type Toggle = {
  [key: string]: boolean;
};

type CurationTab = 'region-curation' | 'experiences-curation' | 'sync-offers' | 'collections' | 'carousel-metrics';

export default function Experiences() {
  const [tab, setTab] = useState<CurationTab>('experiences-curation');
  const { user } = useCurrentUser();
  const showCarouselMetrics = canShowTab(user, [ROLE_ADMIN_USER, ROLE_EXPERIENCES_COORDINATOR]);

  return (
    <Container maxWidth="xl">
      <Tabs sx={{ mb: 2 }} value={tab} onChange={(_, value) => setTab(value)} id="experience-tabs">
        <Tab value="experiences-curation" label="Experiences Curation" />
        <Tab value="region-curation" label="In Flow Region Curation" />
        <Tab value="sync-offers" label="Sync Offers" />
        <Tab value="collections" label="Collections" />
        {showCarouselMetrics && <Tab value="carousel-metrics" label="Carousel Metrics" />}
      </Tabs>

      <Box mt={4}>
        {tab === 'experiences-curation' && <ExperiencesContent />}
        {tab === 'region-curation' && <RegionCuration />}
        {tab === 'sync-offers' && <SyncOffers />}
        {tab === 'collections' && <Collections />}
        {tab === 'carousel-metrics' && showCarouselMetrics && <CarouselMetricsTab />}
      </Box>
    </Container>
  );
}
